module.exports = __webpack_public_path__ + "img/bb_jo_ouverture_juillet2021.a31f521c.jpg";